import { Mutation } from 'graphql/generated/graphqlTypes';

export const mockedBulkAssignVisitorRolesData = (): Pick<Mutation, 'bulkAssignVisitorRoles'> => ({
  bulkAssignVisitorRoles: {
    updated: [],
    errors: []
  }
});
